import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { GameEditForm } from 'src/components/CmsCasinoManagement/GameEditForm/GameEditForm';
import { CategoriesAndGamesCollection } from 'src/domains/casino/state/AppCasino/store/game-store/Game.store';

interface CasinoGameEditPageType {
    collectionData: CategoriesAndGamesCollection;
}

export const CasinoGameEditPage = observer('CasinoGameEditPage', (props: CasinoGameEditPageType) => {
    const { appCasinoState } = useAppStateContext();

    const game =
        props.collectionData.games.find((game) => game.id === appCasinoState.redirectState.casinoIdParam) ?? null;

    if (game === null) {
        return null;
    }

    return (
        <GameEditForm
            gameId={game.id}
            collection={props.collectionData}
        />
    );
});
